import { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { VideoPlayerContext } from "./VideoPlayerContext";

export const VideoContainer = ({ children }: any) => {
    const { ref, inView } = useInView({
        threshold: 0
    });
    const { setPlaying, autoPlayInView, loaded } = useContext(VideoPlayerContext);

    useEffect(() => {
        if (autoPlayInView && loaded) {
            setPlaying(inView);
        }
    }, [inView, loaded, autoPlayInView, setPlaying]);

    return (
        <div ref={ref} className="absolute inset-0 w-full h-full">
            {children}
        </div>
    )
}